// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__IRoNL","footer":"ModalCreateQualiphyProcedure_footer__2QR4W","additionData":"ModalCreateQualiphyProcedure_additionData__3qWuj"};